import { isNil } from 'es-toolkit'

export function capitalizeText(text: string) {
  return text
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

// Converts camelCase, PascalCase, snake_case, kebab-case to "Title Case Words"
export function humanizeFieldName(name: string) {
  return name
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim()
}

export function formatBoolean(value?: boolean | null, trueLabel = 'Yes', falseLabel = 'No') {
  if (isNil(value)) return null
  return value ? trueLabel : falseLabel
}

// Stringify an unknown value: primitives as-is, objects as JSON. Positive typeof narrowing keeps it base-to-string safe.
export function stringifyValue(value: unknown): string {
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'boolean') return String(value)
  return JSON.stringify(value)
}

// Same shape the server uses for a phone on file (***2974), so a number just typed isn't echoed in full.
export function maskPhone(phone: string) {
  const digits = phone.replace(/\D/g, '')
  return digits.length >= 4 ? `***${digits.slice(-4)}` : phone
}
